<template>
    <div class="mb-5">
        <div class="purchase-holder " v-for="(data, index) in orderData">
            <div v-if="data.order_items[0]">
                <div @click="$emit('viewDetail', data)">
                    <div class="purchase-header">
                        <v-layout row>
                            <v-flex class="store-name">
                                <v-icon>mdi-store</v-icon>
                                <span class="text-truncate" style="width: 250px">{{data.branch.name}}</span>
                            </v-flex>
                            <v-flex class="to-pay">
                                <a class="grey--text text--darken-1 font-italic caption" href="javascript:">To Receive</a>
                            </v-flex>
                        </v-layout>
                        <div class="purchase-date">Placed on {{data.created_at}}</div>
                        <div class="purchase-date" v-if="data.payment_id"> {{ `Paid on ${data.paid_at} with ${data.payment.label}` }}</div>
                        <div class="purchase-order">Tracking #{{data.tracking_number}}</div>
                    </div>
                    <div class="purchase-body">
                        <table>
                            <tr>
                                <td class="img">
                                    <v-img aspect-ratio="1" contain :src="data.order_items[0].branch_variation.variation.product.galleries[0].url_thumbnail"></v-img>
                                </td>
                                <td class="purchase-info">
                                    <div class="name">
                                        {{data.order_items[0].branch_variation.variation.product.name}}
                                        <div style="display: inline-block" v-if="typeof data.order_items[0].branch_variation.variation.variation_options[0] !== 'undefined'">
                                            ({{data.order_items[0].branch_variation.variation.variation_options[0].name}})
                                        </div>
                                        <div v-if="typeof data.order_items[0].branch_variation.variation.variation_options[1] !== 'undefined'">
                                            ( {{data.order_items[0].branch_variation.variation.variation_options[1].name}})
                                        </div>
                                    </div>
                                    <div class="status">shipping</div>
                                </td>
                                <td class="value">
                                    <!--<div class="price text-dark">PHP 168.00</div>-->
                                    <!--<div class="quantity text-dark">X1</div>-->
                                    <!--<div class="total">PHP 168.00</div>-->
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="purchase-footer">
                    <v-layout row>
                        <v-flex xs5 class="left">
                            <!--by ${data.payment.created_at}-->
                            <div class="payment-method"> {{ `Shipped with ${data.courier.name} courier` }}</div>
                            <div class="payment-method"> {{ `processed at ${data.processed_at} ` }}</div>
                            <template v-if="data.delivered">
                                <v-btn class="text-capitalize" small depressed color="secondary" @click="$emit('receivedOrder',data)">Received</v-btn>
                                <v-btn class="text-capitalize" small outline depressed color="grey" @click="$emit('disputeOrder',data)">Dispute</v-btn>
                            </template>
                        </v-flex>
                        <v-flex xs7 class="right">
                            <div class="summary">
                                <div class="summary-row">
                                    <div class="label">{{countOrderItemQuantity(data)}} Item/s, Total:</div>
                                    <div class="value red--text">&#8369; {{numberWithCommas(data.subtotal)}}</div>
                                </div>
                                <div class="summary-row">
                                    <div class="label">Shipping Fee:</div>
                                    <div class="value red--text">&#8369; {{numberWithCommas(data.shipping_fee)}}</div>
                                </div>
                                <div class="summary-row">
                                    <div class="label font-weight-bold">Final Total:</div>
                                    <div class="value body-1 red--text">&#8369; <span class="font-weight-bold">{{numberWithCommas(data.total)}}</span></div>
                                </div>
                            </div>
                        </v-flex>
                    </v-layout>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PurchaseBaseClass from "./PurchaseBaseClass";

    export default {
        name: "PurchaseReceiving",
        extends : PurchaseBaseClass,
        props : {
            orderData : {},
        },
        methods : {

        }
    }
</script>
